import { useEffect, useRef } from "react";

import "./Popup.css";


function Popup({ isOpen, setOpen, popupName, children, className, onClose }) {



    const overlay = useRef();

    function handleClose() {
        if (popupName && (popupName === 'contact-popup' || popupName === 'call-back-popup' || popupName === 'full-popup')) {
            onClose()
            return
        }
        setOpen(prevState => ({
            ...prevState,
            [popupName]: false,
        }))
        setTimeout(() => {

        }, 300);

    }

    useEffect(() => {
        function handleOverlayClose(evt) {
            if (overlay.current === evt.target) {
                console.log(popupName)
                if (popupName && (popupName === 'contact-popup' || popupName === 'call-back-popup' || popupName === 'full-popup')) {
                    onClose()
                    return
                }
                handleClose();
            }
        }

        document.addEventListener("mousedown", handleOverlayClose);
        return () => {
            document.removeEventListener("mousedown", handleOverlayClose);
        };
    });



    return (
        <div
            className={`popup ${isOpen ? "popup_opened" : ""}`}
            ref={overlay}
        // onTouchStart={handleClose}
        >
            <div className={`popup__container ${className ? className : ""}`}>
                {children}
            </div>
        </div >
    );
}

export default Popup;
